import {
  AccountSettings,
  OrderDetails,
  Orders,
  PaymentSettings,
  PrivacyPolicyEdit,
  ProductCatalog,
  Returns,
  ShopDetails,
  ShopList,
  // Verticals,
  // VerticalDetails,
  // Categories,
  // CategoryDetails,
  // Subcategories,
  UpcEditor,
  //Collections,
  //BannerDetails,
  //CollectionDetails,
  PromotionCodes,
  PushNotifications,
  VerticalDetails,
  CategoryDetails,
  Invoices,
  AdminInvoices,
  CollectionOrders,
  SubcategoryDetails,
} from "../components-pages";
// verticals, collections features will not be used for now

//import CollectionsDeactive from "../assets/icons/CollectionsDeactive.svg";
//import Collections_Selected from "../assets/icons/Collections_Selectedicons.svg";
//import Menu_Deactive from "../assets/icons/Menu_Deactive.svg";
//import menu_active from "../assets/icons/menu_active.svg";
// Verticals, collections features will not be used for now.

//import CollectionsDeactive from "../assets/icons/CollectionsDeactive.svg";
//import Collections_Selected from "../assets/icons/Collections_Selectedicons.svg";

import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import MessageOutlinedIcon from "@material-ui/icons/MessageOutlined";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";
import CategoryOutlinedIcon from "@material-ui/icons/CategoryOutlined";
import InsertChartOutlinedIcon from '@material-ui/icons/InsertChartOutlined';
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
/* This is remove temporarily for 1.42 release */
/* import StoreOutlinedIcon from "@material-ui/icons/StoreOutlined"; */
import BusinessRoundedIcon from "@material-ui/icons/BusinessRounded";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";

import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import CreditCard from '@material-ui/icons/CreditCard';
import MerchantInvoices from "../components-pages/MerchantInvoices";
import AgencyFeeSummary from "../components-pages/AgencyFeeSummary";
import { Subscriptions } from "../components-pages/Subscriptions";
import { SubscriptionDetailMerchant } from "../components-pages/SubscriptionDetailMerchant";
import { SubscriptionDetailPro } from "../components-pages/SubscriptionDetailPro";
import { TkProTeams } from "../components-pages/TkProTeams";
import { MerchantList } from "../components-pages/MerchantList";
import { MerchantDetailsPage } from "../components-pages/MerchantDetails";
import { AdminShopDetailsPage } from "../components-pages/AdminShopDetails";
import { ProOrganisationDetailsPage } from "../components-pages/ProOrganisationDetails";

const is_able_to_list = [
  "print_orders",
  "reject_orders",
  "view_orders",
  "view_order_region",
  "view_detailed_account_settings",
  "view_package_info_section",
  "view_qr_printable_section",
  "print_item_list",
  "print_labels_again",
  "view_printable_item_list",
  "view_privacy_policy",
  "cancel_collect_orders",
];

export const is_able_to = (operation: string) => {
  const loginAsStr = localStorage.getItem("persist:root");
  const persistStore = JSON.parse(loginAsStr ?? "");
  const login = JSON.parse(persistStore.login);
  const role = login?.role ?? "Shop";
  const abilities = roles?.[role]?.abilities || [];
  return abilities.includes(operation);
};

export const roleName = () => {
  let loginAsStr = localStorage.getItem("persist:root");
  let persistStore = JSON.parse(loginAsStr ?? "{}");
  if (persistStore.login) {
    let login = JSON.parse(persistStore.login);
    return login?.role ?? "Shop";
  }
  return "Shop";
};

export const roles: any = {
  Admin: {
    abilities: [
      "view_order_region",
      "view_orders",
      "view_package_info_section",
      "view_printable_item_list",
    ],
    routes: [
      {
        route: "/admin/upceditor",
        secondRoutes: ["admin/vertical", "admin/category"],
        component: UpcEditor,
        sidebar: "admin.upcEditor",
        icon: CategoryOutlinedIcon,
      },
      // {
      //  route: "/admin/verticals",
      //  component: Verticals,
      //  sidebar: "Verticals",
      //  icons: { active: menu_active, passive: Menu_Deactive },
      // },
      {
        route: "/admin/vertical/:id",
        component: VerticalDetails,
      },
      // {
      //  route: "/admin/categories",
      //  component: Categories,
      //  sidebar: "Categories",
      //  icons: { active: menu_active, passive: Menu_Deactive },
      // },
      {
        route: "/admin/category/:id",
        component: CategoryDetails,
      },
      {
        route: "/admin/subcategory/:id",
        component: SubcategoryDetails,
      },
      // {
      //  route: "/admin/subcategories",
      //  component: Subcategories,
      //  sidebar: "Sub Categories",
      //  icons: { active: menu_active, passive: Menu_Deactive },
      // },
      //{
      //  route: "/admin/collections",
      //  component: Collections,
      //  sidebar: "Collections",
      //  icons: { active: Collections_Selected, passive: CollectionsDeactive },
      //},
      //{
      //  route: "/admin/banner/:id",
      //  component: BannerDetails,
      //},
      //{
      //  route: "/admin/collection/:id",
      //  component: CollectionDetails,
      //},
      {
        route: "/admin/orders/",
        secondRoutes: ["admin/orders/details/", "orders/details"],
        component: Orders,
        sidebar: "orders.title",
        icon: AssignmentOutlinedIcon,
        // icons: { active: ordersIconActive, passive: ordersIcon },
      },
      /* {
        route: "/delivery-orders",
        secondRoutes: ["delivery-order", "new-delivery-order"],
        component: CollectionOrders,
        sidebar: "collectionOrders.title",
        icon: LocalShippingOutlinedIcon,
      }, */
      {
        route: "/admin/orders/:isFromDetails?",
        component: Orders,
      },
      {
        route: "/admin/invoices",
        component: AdminInvoices,
        sidebar: "invoices.title",
        icon: ReceiptOutlinedIcon,
      },
      {
        route: "/admin/agency-fee-summary",
        component: AgencyFeeSummary,
        sidebar: "admin.agencyFeeSummary",
        icon: InsertChartOutlinedIcon,
      },
      {
        route: "/admin/promotioncodes",
        component: PromotionCodes,
        sidebar: "admin.promotionCodes",
        icon: LocalOfferOutlinedIcon,
      },
      { route: "/admin/orders/details/:id?", component: OrderDetails },
      {
        route: "/admin/notifications",
        component: PushNotifications,
        sidebar: "admin.pushNotifications",
        icon: MessageOutlinedIcon,
      },
      {
        route: "/admin/subscriptions",
        component: Subscriptions,
        sidebar: "admin.subscriptions",
        icon: CreditCard,
        secondRoutes: ["subscription/merchant", "subscription/pro"],
      },
      {
        route: "/admin/subscription/merchant/:id",
        component: SubscriptionDetailMerchant,
      },
      {
        route: "/admin/subscription/pro/:id",
        component: SubscriptionDetailPro,
      },
      {
        route: "/admin/tk-pro-teams",
        component: TkProTeams,
        sidebar: "admin.tkProTeams",
        icon: BusinessRoundedIcon,
        secondRoutes: ["admin/pro"],
      },
      {
        route: "/admin/merchants",
        component: MerchantList,
        sidebar: "admin.merchants",
        icon: PeopleOutlineIcon,
        secondRoutes: ["admin/merchant/"]
      },
      {
        route: "/admin/merchant/:id",
        component: MerchantDetailsPage,
      },
      {
        route: "/admin/merchant/:merchantId/shop/:id",
        component: AdminShopDetailsPage,
      },
      {
        route: "/admin/pro/:id",
        component: ProOrganisationDetailsPage,
      },
    ],
  },
  Merchant: {
    abilities: [
      "view_order_region",
      "view_detailed_account_settings",
      "view_privacy_policy",
    ],
    routes: [
      /* This is remove temporarily for 1.42 release */
      /*
{
        route: "/merchant/shops",
        component: ShopList,
        sidebar: "Shops",
        icon: StoreOutlinedIcon,
      }, */

      //{
      //  route: "/merchant/productcatalog",
      //  component: ProductCatalog,
      //  sidebar: "Product Catalogue",
      //  icons: { active: menu_active, passive: Menu_Deactive },
      //},
      {
        route: "/merchant/orders",
        component: Orders,
        sidebar: "orders.title",
        icon: AssignmentOutlinedIcon,
      },
      {
        route: "/merchant/privacy-policy/:returnswindow",
        component: PrivacyPolicyEdit,
      },
      {
        route: "/merchant/orders/details/:id?",
        component: OrderDetails,
      },

      /* This is remove temporarily for 1.42 release */
      /* { route: "/merchant/shops/:id", component: ShopDetails }, */

      //{
      //  route: "/merchant/paymentsettings",
      //  component: PaymentSettings,
      //  sidebar: "Payment Settings",
      //  icons: { active: paymentSettingsActive, passive: paymentSettings },
      //},

      /* This is remove temporarily for 1.42 release */
      /* {
        route: "/merchant/account-settings",
        component: AccountSettings,
        sidebar: "Account Settings",
        icon: BusinessRoundedIcon,
      }, */
      {
        route: "/invoices",
        component: MerchantInvoices,
        sidebar: "invoices.title",
        icon: ReceiptOutlinedIcon,
      },
      {
        route: "/agency-fee-summary",
        component: AgencyFeeSummary,
        sidebar: "admin.agencyFeeSummary",
        icon: InsertChartOutlinedIcon,
      },
      {
        route: "/subscription",
        component: SubscriptionDetailMerchant,
        sidebar: "admin.subscriptions",
        icon: CreditCard,
      },
    ],
  },
  Shop: {
    abilities: [
      "print_orders",
      "reject_orders",
      "view_orders",
      "view_package_info_section",
      "print_item_list",
      "view_qr_printable_section",
      "print_labels_again",
      "view_printable_item_list",
    ],
    routes: [
      {
        route: "/orders",
        component: Orders,
        sidebar: "orders.title",
        icon: AssignmentOutlinedIcon,
        secondRoutes: ["orders/details"],
      },
      {
        route: "/invoices",
        component: Invoices,
        sidebar: "invoices.title",
        icon: ReceiptOutlinedIcon,
      },
      { route: "/orders/details/:id?", component: OrderDetails },
      { route: "/returns", component: Returns },
    ],
  },
  all: {
    abilities: is_able_to_list,
    routes: [
      { route: "/merchant/shops", component: ShopList, sidebar: "Shops" },
      { route: "/merchant/shops/:id", component: ShopDetails },
      {
        route: "/merchant/productcatalog",
        component: ProductCatalog,
        sidebar: "Product Catalogue",
      },
      {
        route: "/orders",
        component: Orders,
        sidebar: "orders.title",
        secondRoutes: ["orders/details"],
      },
      { route: "/orders/details/:id?", component: OrderDetails },
      {
        route: "/merchant/paymentsettings",
        component: PaymentSettings,
        sidebar: "Payment Settings",
      },
      {
        route: "/account-settings",
        component: AccountSettings,
        sidebar: "Account Settings",
      },
      { route: "/returns", component: Returns },
    ],
  },
  CollectionEnabled: {
    abilities: ["view_orders", "cancel_collect_orders"],
    routes: [
      {
        route: "/delivery-orders",
        secondRoutes: ["delivery-order", "new-delivery-order"],
        component: CollectionOrders,
        sidebar: "collectionOrders.title",
        icon: LocalShippingOutlinedIcon,
      },
      {
        route: "/delivery-dashboard",
        component: CollectionOrders,
        sidebar: "collectionDashboard.title",
        icon: DashboardOutlinedIcon,
      }
    ]
  },
  CollectionOnly: {
    abilities: ["view_orders", "cancel_collect_orders"],
    routes: [
      {
        route: "/delivery-orders",
        secondRoutes: ["delivery-order", "new-delivery-order"],
        component: CollectionOrders,
        sidebar: "collectionOrders.title",
        icon: LocalShippingOutlinedIcon,
      },
      {
        route: "/delivery-dashboard",
        component: CollectionOrders,
        sidebar: "collectionDashboard.title",
        icon: DashboardOutlinedIcon,
      },
      {
        route: "/invoices",
        component: Invoices,
        sidebar: "invoices.title",
        icon: ReceiptOutlinedIcon,
      },
    ],
  },
};
